// Newsletter popup — shows once on interior pages, never again after dismiss or subscribe
class NewsletterPopup extends HTMLElement {
  constructor() {
    super();

    // Skip on Shopify robot challenge page
    if (window.location.pathname === '/challenge') return;

    this.storageKey = 'rd:newsletter-popup';

    // If the success message is in the DOM, the form was just submitted — mark done and show
    if (this.querySelector('.rd-newsletter-popup__success')) {
      this.markDone();
      // Wire close triggers before opening so the button works on the success screen
      this.querySelectorAll('[data-popup-close]').forEach((el) => {
        el.addEventListener('click', () => this.dismiss());
      });
      this.open();
      return;
    }

    // If already dismissed or subscribed, do nothing
    if (localStorage.getItem(this.storageKey)) return;

    // Wire up close triggers
    this.querySelectorAll('[data-popup-close]').forEach((el) => {
      el.addEventListener('click', () => this.dismiss());
    });

    // Show after delay
    const delay = parseInt(this.dataset.delay, 10) || 0;
    setTimeout(() => this.open(), delay * 1000);
  }

  open() {
    // Re-check localStorage — footer signup may have set it during the delay
    if (localStorage.getItem(this.storageKey)) return;
    this.classList.add('is-active');
    document.body.classList.add('rd-newsletter-popup--open');
  }

  dismiss() {
    this.markDone();
    this.classList.add('is-closing');

    // Remove active class after animation finishes
    setTimeout(() => {
      this.classList.remove('is-active', 'is-closing');
      document.body.classList.remove('rd-newsletter-popup--open');
    }, 300);
  }

  markDone() {
    localStorage.setItem(this.storageKey, '1');
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
